var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary--text",attrs:{"id":"hashtag"}},[_c('span',[_vm._v("#SITCONxHK")]),_vm._v(" "),_c('span',[_vm._v("#SITCONxHK2017")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34292eaa","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hashtag.vue
// module id = 68
// module chunks = 0